import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import thptEn from './locales/en.json';
import thptVi from './locales/vi.json';

const resources = {
  en: {
    translation: thptEn,
  },
  vi: {
    translation: thptVi,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'vi', // Default language for THPT app
  fallbackLng: 'vi',
  interpolation: {
    escapeValue: false, // React handles escaping
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
